import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveStoreAssetMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  markDeleted?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type RemoveStoreAssetMutation = { __typename?: 'Mutation', removeStoreAsset: boolean };


export const RemoveStoreAssetDocument = gql`
    mutation RemoveStoreAsset($id: ID!, $markDeleted: Boolean) {
  removeStoreAsset(id: $id, mark_deleted: $markDeleted)
}
    `;
export type RemoveStoreAssetMutationFn = Apollo.MutationFunction<RemoveStoreAssetMutation, RemoveStoreAssetMutationVariables>;

/**
 * __useRemoveStoreAssetMutation__
 *
 * To run a mutation, you first call `useRemoveStoreAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStoreAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStoreAssetMutation, { data, loading, error }] = useRemoveStoreAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      markDeleted: // value for 'markDeleted'
 *   },
 * });
 */
export function useRemoveStoreAssetMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStoreAssetMutation, RemoveStoreAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStoreAssetMutation, RemoveStoreAssetMutationVariables>(RemoveStoreAssetDocument, options);
      }
export type RemoveStoreAssetMutationHookResult = ReturnType<typeof useRemoveStoreAssetMutation>;
export type RemoveStoreAssetMutationResult = Apollo.MutationResult<RemoveStoreAssetMutation>;
export type RemoveStoreAssetMutationOptions = Apollo.BaseMutationOptions<RemoveStoreAssetMutation, RemoveStoreAssetMutationVariables>;